"use client"

import type React from "react"
import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@/presentation/hooks/useAuth"
import type { UserRole } from "@/domain/enums/roles"
import { redirectByRole } from "@/presentation/utils/helpers"

interface PrivateRouteProps {
  children: ReactNode
  allowedRoles: UserRole[]
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, isLoading } = useAuth()
  const location = useLocation()
  const isPasswordResetFlow = location.pathname === '/reset-password';

  if (!isAuthenticated && !user && !isLoading) {
    return <Navigate to="/login" replace />
  }

  if (!allowedRoles.includes(user?.role as UserRole) && !isPasswordResetFlow) {
      const redirectPath = redirectByRole(user?.role as UserRole)
      return <Navigate to={redirectPath} replace />
  }

  return <>{children}</>
}

export default PrivateRoute
